import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import CourseDetailsV2 from './CourseDetailsV2';
import PublicCourseDetails from './PublicCourseDetails';

const CourseDetailRouter = () => {
  const isAuth = useSelector((state) => !!state.main.userId);
  const currentUserId = useSelector((state) => state.main.userId);
  const { id } = useParams();
  const [courseOwnerId, setCourseOwnerId] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchCourseOwner = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_SERVER}/api/courses/${id}`);
        console.log('Course data:', response.data); // Debug log
        
        // Handle both array and single object responses
        const courseData = Array.isArray(response.data) ? response.data[0] : response.data;
        
        if (courseData) {
          // Handle different possible userId field structures
          const ownerId = courseData.userId || 
                         (Array.isArray(courseData.userId) ? courseData.userId[0] : courseData.userId) ||
                         courseData.by; // fallback to 'by' field
          
          console.log('Course owner ID:', ownerId); // Debug log
          console.log('Current user ID:', currentUserId); // Debug log
          
          setCourseOwnerId(ownerId);
        }
      } catch (error) {
        console.error('Error fetching course owner:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchCourseOwner();
  }, [id, currentUserId]);

  // Avoid double loaders; inner components handle their own loading states
  if (loading) return null;

  // If user is not authenticated, show the public version without Layout
  if (!isAuth) {
    return <PublicCourseDetails />;
  }

  // If user is authenticated, check if they own the course
  const isOwnCourse = currentUserId && courseOwnerId && currentUserId === courseOwnerId;
  
  // If user owns the course, show the protected version with Layout
  if (isOwnCourse) {
    return <CourseDetailsV2 />;
  }
  
  // If user is authenticated but viewing someone else's course, show public version
  return <PublicCourseDetails />;
};

export default CourseDetailRouter;
